import React, { Component } from "react";
import Cognito from "src/js/Cognito.js";
import Api from "src/js/Api.js";
import { Route, Switch } from "react-router-dom";
import NoRankingData from "src/component/Ranking/NoRankingData";
import RankingMonthlyGraph from "src/component/Ranking/RankingMonthlyGraph";
import RankingScore from "src/component/Ranking/RankingScore";
import { Row, Col } from "react-bootstrap";
import Modal from "src/js/Modal.js";
import ApiErrorModal from "src/js/ApiErrorModal.js";
import Config from "src/config.json";
import "src/css/Ranking.css";
import 'src/i18n';
import { withTranslation } from 'react-i18next';

class Ranking extends Component {
  constructor() {
    super();
    this.state = {
      // ログイン中ユーザ
      cognitoUser: [],
      // ログイン者のsub
      sub: "",
      // 車両のカープレートNO
      carPlateNo: "",
      // ランキング情報
      rankingInfo: [],
      // 月次ランキング
      monthlyRanking: [],
      // ラベル
      labels:[],
      // 最新日
      date:"",
      // ランキング情報データローディング
      rankingInfoLoading: false,
      // ランキング情報存在フラグ
      isRankingInfo: true,
      // ランキング存在フラグ
      isRanking: true,
      modalApiPath: "",
      modalStatusCode: "",
      modalErrorMessage: "",
      modalApiMessage: "",

      isOpen: false,
    };

    this.getLocalStorageData = this.getLocalStorageData.bind(this);
    this.handleHideModal = this.handleHideModal.bind(this);
    this.handleShowModal = this.handleShowModal.bind(this);
  }

  componentWillMount() {
    // 認証チェック
    if (Cognito.signInCheck()) {
      // ユーザを取得
      this.setState({ cognitoUser: Cognito.getCognitoUser() });
    }
    // 描画前にローカルストレージからデータを取得する
    this.getLocalStorageData();
  }

  componentDidMount() {
    // ページの一番上までスクロール
    window.scrollTo(0, 0);
    this.getRankingInfo();
  }

  handleHideModal() {
    this.setState({ showModal: false });
  }

  handleShowModal() {
    this.setState({ showModal: true });
  }

  // ローカルストレージの値を取得
  getLocalStorageData() {
    // サブ情報
    let sub = localStorage.getItem("sub");
    if (sub) {
      this.setState({
        sub: sub,
      });
    }

    // カープレートNO
    let carPlateNo = localStorage.getItem("carPlate");
    if (carPlateNo) {
      this.setState({
        carPlateNo: carPlateNo,
        carInfoLoading: true,
        isCarInfo: true,
      });
    }
  }
  
  // ランキング情報を取得
  getRankingInfo() {
    // subが無い場合は失敗とする
    if (!this.state.sub) {
      this.setState({
        isRankingInfo: false,
        rankingInfoLoading: false,
      });
      return;
    }

    let _this = this;

    let queryParams = {
      sub: this.state.sub,
    };

    this.setState({
      isRankingInfo: true,
      rankingInfoLoading: true,
    });

    // APIの実行
    Api.runApi(
      this.state.cognitoUser,
      Config.API.STAGE + Config.API.RANKING.RANKING_PATH,
      queryParams
    )
      .then(function onFulfilled(result) {

        // ランキンググラフの最大y軸を計算
        let maxYAxes = 0;
        for (const ranking of result.data.monthlyRanking) {
          if (maxYAxes < ranking) {
            maxYAxes = ranking;
          }
        }
        do {
          maxYAxes++;
        } while (maxYAxes% 10 !== 5 && maxYAxes% 10 !== 0)

        console.log(result.data.latestValue.latestDate)
        // Stateを更新
        _this.setState({
          rankingInfo: result.data.latestValue ? result.data.latestValue :{},
          monthlyRanking: result.data.monthlyRanking,
          maxYAxes: maxYAxes,
          labels: result.data.labels,
          rankingInfoLoading: false,
          isRanking: result.data.latestValue && result.data.latestValue.ranking ? true :false,
          date: result.data.latestValue.latestDate
        });
      })
      .catch(function onRejected(err) {
        console.log(err);
        _this.setState({
          isRankingInfo: false,
          isRanking:false,
          rankingInfoLoading: false,
          showModal: true,
          modalErrorMessage: "RankingApiError",
          modalApiPath: err.response && err.response.request.responseURL,
          modalStatusCode: err.response && err.response.status,
          modalApiMessage: err.response && err.response.data.errorMessage,
          error: !err.response && err,
        });
        return;
      });
  }

  render() {    
    if (this.state.error) {
      throw new Error(this.state.error);
    }

    return (
      <div>
        <Modal isAospBrowser={false} isLocalStorage={true} />
        <Switch>
          {/* ランキング画面 */}
          <Route exact path="/ranking">
            <div>
              {this.state.showModal && (
                <ApiErrorModal
                  handleHideModal={this.handleHideModal}
                  modalErrorMessage={this.state.modalErrorMessage}
                  modalApiPath={this.state.modalApiPath}
                  modalStatusCode={this.state.modalStatusCode}
                  modalApiMessage={this.state.modalApiMessage}
                />
              )}
              <Row>
                <Col md={6} sm={6} xs={6} className="car-information">
                  <div>
                    {this.state.carPlateNo}
                  </div>
                </Col>
                <Col md={6} sm={6} xs={6} className="car-information">
                  <div>
                    {this.state.date}
                  </div>
                </Col>
                <Col md={12} sm={12} xs={12}>
                  <NoRankingData isRanking={this.state.isRanking} />
                </Col>
                <Col md={12} sm={12} xs={12} id="ranking-score-chart">
                  <RankingScore
                    rankingInfo={this.state.rankingInfo}
                    isData={this.state.isRankingInfo}
                    loading={this.state.rankingInfoLoading}
                  />
                </Col>
                <Col md={12} sm={12} xs={12} id="ranking-monthly-graph">
                  <RankingMonthlyGraph
                    data={this.state.monthlyRanking}
                    labels={this.state.labels}
                    maxYAxes={this.state.maxYAxes}
                    isData={this.state.isRankingInfo}
                    loading={this.state.rankingInfoLoading}
                  />
                </Col>
              </Row>
            </div>
          </Route>
        </Switch>
      </div>
    );
  }
}

export default withTranslation()(Ranking);


// WEBPACK FOOTER //
// ./src/component/Ranking/Ranking.js